import { safeCss } from '@frontend/web-utils';
import type { SkeletonProps as MSkeletonProps } from '@mantine/core';
import { Skeleton as MSkeleton } from '@mantine/core';

export type SkeletonProps = MSkeletonProps;

export const Skeleton = (props: SkeletonProps) => (
  <MSkeleton classNames={{ root: safeCss('bg-neutral-50') }} {...props} />
);
